import React from "react";
// import { RiArrowRightSFill, RiArrowDownSFill } from "react-icons/ri";
import "../css/arrival.css";
import { cardsData } from "../rawData/kidsAPI";
import BrandList from "../components/BrandList";
import ColorList from "../components/ColorList";
import ProductCards from "../components/ProductCards";
import SizeList from "../components/SizeList";
import PriceList from "../components/PriceList";
import LinkLists from "../components/LinkLists";

const NewArrivalsPage = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="new-container">
          <div className="d-flex border-bottom justify-content-between p-3">
            <div className="d-flex justify-content-between">
              <div>
                <h6>MEN'S NEW ARRIVALS COLLECTION</h6>
                <p>{cardsData.length} style</p>
              </div>
              <div className="pl-5">
                <ol class="breadcrumb">
                  <li>{window.location.pathname}</li>
                </ol>
              </div>
            </div>
            <div>
              <form>
                <div class="form-group">
                  <select class="form-control">
                    <option>New</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-3 col-lg-2 col-xl-2">
              <div className="sideBox p-3 ">
                <LinkLists/>

                <BrandList />
                <ColorList />
                <SizeList />
                <PriceList />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-9 col-lg-10 col-xl-10">
              <ProductCards />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewArrivalsPage;
